/**
 * Created by Fernando Torres on 18/04/2018.
 */
import BaseStore from '../base-store'

let options = {}
export default new BaseStore('dealer-division-scores', options)



// WEBPACK FOOTER //
// ./src/store/dealer-division-scores/index.js